// src/Pages/Social/SocialContentPage.jsx
//
// "Tell us what's happening": the full page. The box, a link to drafts
// waiting for review, and the owner's recent updates. The old Generate /
// History / Analytics tabs read content_requests and are retired.

import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { Box, Container, AppBar, Toolbar, IconButton, Typography, Paper, Button, Grid } from '@mui/material';
import { ArrowBack as BackIcon, Campaign as CampaignIcon, RateReview as DraftsIcon } from '@mui/icons-material';
import { useGetDraftsQuery } from '../../redux/thunks/drafts/getdrafts';
import AnnouncementBox from '../Announcements/AnnouncementBox';
import RecentAnnouncements from '../Announcements/RecentAnnouncements';

export default function SocialContentPage() {
  const { businessId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const businessName = location.state?.businessName || 'Your Business';

  const { data: pending } = useGetDraftsQuery(
    { businessId, status: 'pending_approval' }, { skip: !businessId, pollingInterval: 60000 });
  const pendingCount = pending?.total || 0;

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'grey.50' }}>
      <AppBar position="sticky" color="default" elevation={0}
              sx={{ borderBottom: 1, borderColor: 'divider', bgcolor: 'background.paper' }}>
        <Toolbar>
          <IconButton edge="start" onClick={() => navigate(-1)} sx={{ mr: 1 }}><BackIcon /></IconButton>
          <CampaignIcon color="primary" sx={{ mr: 1 }} />
          <Box sx={{ flexGrow: 1 }}>
            <Typography variant="h6" fontWeight={600}>Tell us what's happening</Typography>
            <Typography variant="caption" color="text.secondary">{businessName}</Typography>
          </Box>
        </Toolbar>
      </AppBar>

      <Container maxWidth="md" sx={{ py: 3, px: { xs: 2, sm: 3 } }}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Paper variant="outlined" sx={{ p: { xs: 2, sm: 3 } }}>
              <AnnouncementBox businessId={businessId} />
            </Paper>
          </Grid>

          <Grid item xs={12}>
            <Paper variant="outlined" sx={{ p: 2, display: 'flex', alignItems: 'center', gap: 1.5 }}>
              <DraftsIcon color={pendingCount ? 'warning' : 'action'} />
              <Typography variant="body2" sx={{ flex: 1 }}>
                {pendingCount
                  ? `${pendingCount} draft${pendingCount === 1 ? '' : 's'} waiting for your review`
                  : 'No drafts waiting for review'}
              </Typography>
              <Button size="small" variant={pendingCount ? 'contained' : 'outlined'}
                      onClick={() => navigate(`/business/${businessId}/drafts`, { state: { businessName } })}>
                {pendingCount ? 'Review' : 'View drafts'}
              </Button>
            </Paper>
          </Grid>

          <Grid item xs={12}>
            <RecentAnnouncements businessId={businessId} />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}